import { useEffect, useState } from "react";
import { useLang } from "../contexts/LanguageContext";

export default function ShareDialog({ open, onClose, url }) {
    const { t } = useLang();
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!open) setCopied(false);
    }, [open]);

    if (!open) return null;

    const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&bgcolor=14171c&color=ff7a18&margin=10&data=${encodeURIComponent(
        url,
    )}`;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {}
    };

    return (
        <div
            className="fixed inset-0 z-[2000] flex items-center justify-center px-4"
            style={{ background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)" }}
            onClick={onClose}
            data-testid="share-dialog-backdrop"
        >
            <div
                className="rf-card grain relative max-w-md w-full p-6 fade-up"
                style={{ background: "var(--bg-card-solid)" }}
                onClick={(e) => e.stopPropagation()}
                data-testid="share-dialog"
            >
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-[var(--text-faint)] hover:text-[var(--accent)]"
                    data-testid="share-close"
                >
                    <i className="fa-solid fa-xmark"></i>
                </button>
                <h3 className="font-display font-bold text-lg mb-1">
                    <i className="fa-solid fa-share-nodes text-[var(--accent)] mr-2"></i>
                    {t("shareRoute")}
                </h3>
                <p className="text-xs text-[var(--text-muted)] mb-4">
                    {t("shareDesc")}
                </p>

                <div className="flex justify-center my-3">
                    <img
                        src={qrUrl}
                        alt="QR code"
                        className="rounded-xl border border-[var(--border-strong)]"
                        data-testid="share-qr"
                    />
                </div>

                <div className="flex items-center gap-2 mb-3">
                    <input
                        type="text"
                        value={url}
                        readOnly
                        className="rf-input flex-1 font-mono-stat text-[10px]"
                        onClick={(e) => e.target.select()}
                        data-testid="share-url"
                    />
                    <button
                        className={`rf-btn ${copied ? "primary" : ""}`}
                        onClick={copy}
                        data-testid="share-copy"
                    >
                        <i className={`fa-solid ${copied ? "fa-check" : "fa-copy"}`}></i>
                        {copied ? t("copied") : t("copy")}
                    </button>
                </div>

                <div className="text-[10px] text-[var(--text-faint)] text-center">
                    {t("shareTip")}
                </div>
            </div>
        </div>
    );
}
